import { Button, Card, Loading, Modal, Option, Select, SingleDatePicker, Tag, Text, TextArea, Tooltip } from '@sede-enterprise/shell-ds-react-framework'
import Plot from 'react-plotly.js'
import useGetCancuiDetails from '../hooks/useGetCancuiDetails';
import ProbabilityScoreGrid from './ProbabilityScoreGrid';
import moment from 'moment'
import { handleDateChange } from '../../../util/handleDateChange'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import { useContext, useEffect, useState } from 'react';
import { DEFAULT_STATS_SPEC, DEFAULT_HOURLY_DATE_SPEC } from '../../../util/constants';
import { UnitContext, UserContext } from '../../../App';
import useGetTempChartData from '../hooks/useGetTempChartData';
import { getMinMaxFromGraphData } from '../../../util/helperFunctions';
import { getHighlightClass, shouldHighlightCriticality } from '../utils/cancuiUtils';
import useGetTemperatureFormulaData from '../hooks/useGetTemperatureFormulaData';
import CondensateRiskSummaryList from './CondensateRiskSummaryList';
import { toast } from 'react-toastify';
import useGetSensorDetails from '../hooks/useGetSensorDetails';
import useGetTagAnalysisDates from '../hooks/useGetTagAnalysisDates';
import { fetchData } from '../../../api/cancuiApi';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from "@azure/msal-browser";
import DataTable from '../../../components/DataTable/DataTable';
import useGetTemperatureFormulaTagData from '../hooks/useGetTemperatureFormulaTagData';
import PressureLookupTemperature from './PressureLookupTemperature';

const probabilityClassMap = {
    'H': '>20',
    'M': '17-20',
    'L': '11-16',
    'N': '1-10'
}

const INIT_PAGE = 1;
const INIT_ORDER = "timestamp";
const INIT_ORDER_DIRECTION = 0


const CancuiSensorDetails = ({ match, setModalSubmitted, modalSubmitted, equipmentData }) => {

    const { units } = useContext(UnitContext)
    const [startDate, setStartDate] = useState(DEFAULT_STATS_SPEC.initStart);
    const [endDate, setEndDate] = useState(DEFAULT_STATS_SPEC.initEnd);
    const [startErrorText, setStartErrorText] = useState(null);
    const [inValidStartDate, setInValidStartDate] = useState(null);
    const [endErrorText, setEndErrorText] = useState(null);
    const [inValidEndDate, setInValidEndDate] = useState(null);
    // Condensate risk states
    const [condensateRisk, setCondensateRisk] = useState(-1);
    const [isCondensateRiskAssementComplete, setIsCondensateRiskAssementComplete] = useState(false);
    const [coatingCondition, setCoatingCondition] = useState(-1);
    const [comments, setComments] = useState('');
    const [condensateRiskAnsweredBy, setCondensateRiskAnsweredBy] = useState("");
    const [open, setOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [pressureLookupOpen, setPressureLookupOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(INIT_PAGE);
    const [cancuiOrder, setCancuiOrder] = useState(INIT_ORDER);
    const [orderDirection, setOrderDirection] = useState(INIT_ORDER_DIRECTION);
    const [tempFormulaInterval, setTempFormulaInterval] = useState("DAY");
    const [tempFormulaStartDate, setTempFormulaStartDate] = useState(DEFAULT_STATS_SPEC.initStart);
    const [tempFormulaEndDate, setTempFormulaEndDate] = useState(DEFAULT_STATS_SPEC.initEnd);
    const [tempFormulaStartErrorText, setTempFormulaStartErrorText] = useState(null);
    const [inValidtempFormulaStartDate, setInValidtempFormulaStartDate] = useState(null);
    const [tempFormulaEndErrorText, setTempFormulaEndErrorText] = useState(null);
    const [inValidtempFormulaEndDate, setInValidtempFormulaEndDate] = useState(null);

    const handleOrderChange = (sortBy, direction) => {
        setCancuiOrder(sortBy);
        setOrderDirection(+direction);
    }

    const handleCurrentPageChange = (current) => {
        setCurrentPage(current);
    }
    
    const handleOnClose = () => setOpen(false);

    const handleOnPressureLookupClose = () => setPressureLookupOpen(false);

    const { instance, inProgress } = useMsal();
    const [userMail, setUserMail] = useState("")
    const activeAccount = inProgress === InteractionStatus.None ? instance.getActiveAccount() : null;
    useEffect(() => {
        if (activeAccount) {
            console.log("cancui user: ", activeAccount)
            setUserMail(activeAccount.username.toLowerCase())
        } else {
            setUserMail(null);
        }
    }, [activeAccount]);

    const handleOnConfirm = () => {
        // Handle confirm action
        // merge user confirmation and comments
        setModalLoading(true);
        fetchData("submit_condensateRisk_answers", { "sensor_id": `${equipmentData.id}`,  
            condensateRisk: `${condensateRisk}`,
            coatingPerformanceAcceptable: `${coatingCondition}`,
            condensateRiskComments: comments,
            condensateRiskAnsweredBy: userMail
        })
            .then((res) => {
                setModalLoading(false);
                setModalSubmitted(true);
                handleOnClose();
                toast.success("Submitted Answers");
                // setPromoteJobId(res.id);
            }).catch((error) => {
                setModalLoading(false);
                handleOnClose();
                console.log(error);
                toast.error("Error submitting answers");
            })
    }


    const {data: sensorData, isLoading: sensorLoading} = useGetSensorDetails(equipmentData.id, modalSubmitted);
    useEffect(() => {
        if (sensorData) {
            const isCondensateRiskAssementCompleteLocal = sensorData.condensateRisk != -1 ? true : false
            setCoatingCondition(sensorData.coatingPerformanceAcceptable);
            setCondensateRisk(sensorData.condensateRisk);
            setComments(isCondensateRiskAssementCompleteLocal ? sensorData.condensateRiskComments : "");
            setCondensateRiskAnsweredBy((isCondensateRiskAssementCompleteLocal && sensorData.condensateRiskAnsweredBy) ? sensorData.condensateRiskAnsweredBy : "");
            setIsCondensateRiskAssementComplete(isCondensateRiskAssementCompleteLocal);
        }
    }, [sensorData]);

    const { data, isLoading } = useGetCancuiDetails(equipmentData.id);
    const { data: tempChartData, loading: tempChartLoading } = useGetTempChartData(equipmentData.id, startDate, endDate, units, equipmentData?.site?.id);
    const { min: minValue, max: maxValue } = getMinMaxFromGraphData(tempChartData);
    const { data: analysisDates, isLoading: analysisDatesLoading } = useGetTagAnalysisDates(equipmentData.id, equipmentData);
    const isCondensateRisk = equipmentData?.condensateRiskDetected ?  equipmentData?.condensateRiskDetected : false;
    const { data: temperatureFormulaData, tagList: tagList, isLoading: temperatureFormulaDataLoading } = useGetTemperatureFormulaData(equipmentData.id, analysisDates, isCondensateRisk);
    console.log("temperatureFormulaData", temperatureFormulaData, temperatureFormulaDataLoading);
    const tags = tagList?.tags || [];
    const displayFormula = tagList?.display_formula || "";
    const pressure_tags = tagList?.pressure_tags || [];
    const flow_tags = tagList?.flow_tags || [];
    const tempFormulaIntervalValue = tempFormulaInterval === "HOUR" ? "H" : tempFormulaInterval === "DAY" ? "D" : "D";
    const { data: temperatureFormulaTagData, isLoading: temperatureFormulaTagDataLoading } = useGetTemperatureFormulaTagData(equipmentData.id, tempFormulaStartDate, tempFormulaEndDate, tempFormulaIntervalValue, units, tags);
    console.log("temperatureFormulaTagData", temperatureFormulaTagData, temperatureFormulaTagDataLoading);
    const agreedCondensateRiskText = "You agreed with the condensate risk. Temperature and Environment are scored as 5";
    const disagreedCondensateRiskText = "You did not agree with the condensate risk. Temperature, Environment and Coating Condition are scored based on equipment data.";
    const agreedCoatingConditionText = "You agreed the coating condition is acceptable. Coating Condition is scored based on equipment data.";
    const disagreedCoatingConditionText = "You did not agree the coating condition is acceptable. Coating Condition is scored as 5.";
    return (
                <div className='content-body'>
                    <h4>Temperature Graph</h4>
                    <div className='chart-date-container'>
                        <div className='start-date-wrapper'>
                            <div className='label-header'>
                                <p className="data-label">Start Date</p>
                                <Button variant='transparent' iconOnly />
                            </div>
                            <SingleDatePicker
                                generateConfig={momentGenerateConfig}
                                config="custom"
                                format="DD/MM/yyyy"
                                disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                                value={!inValidStartDate && startDate ? startDate : inValidStartDate ? inValidStartDate : null}
                                onChange={(date) => {
                                    setStartErrorText(null)
                                    setInValidStartDate(null)
                                    if (date.isBefore(endDate)) {
                                        handleDateChange(date, startDate, setStartDate, "DD/MM/yyyy")
                                    }
                                    else if (date.isAfter(endDate)) {
                                        setStartErrorText("Start date cannot be after end date")
                                        setInValidStartDate(date)
                                    }
                                }
                                }
                                allowClear={false} />
                            <p className="data-label error-label">{startErrorText}</p>
                        </div>
                        <div className='end-date-wrapper'>
                            <div className='label-header'>
                                <p className="data-label">End Date</p>
                                <Button variant='transparent' iconOnly />
                            </div>
                            <SingleDatePicker
                                generateConfig={momentGenerateConfig}
                                config="custom"
                                format="DD/MM/yyyy"
                                disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                                value={!inValidEndDate && endDate ? endDate : inValidEndDate ? inValidEndDate : null}
                                onChange={(date) => {
                                    setEndErrorText(null)
                                    setInValidEndDate(null)
                                    if (date.isAfter(startDate)) {
                                        handleDateChange(date, endDate, setEndDate, "DD/MM/yyyy")
                                    }
                                    else if (date.isBefore(startDate)) {
                                        setEndErrorText("End date cannot be before start date")
                                        setInValidEndDate(date)
                                    }
                                }
                                }
                                allowClear={false} />
                            <p className="data-label error-label">{endErrorText}</p>
                        </div>
                    </div>
                    <div className='cancui-card-container'>
                        <div className='cancui-left-card'>

                            <Card className='details-card temp-card' bodyPadding={false}>
                                {tempChartLoading && <div className='loading-container'><Loading /></div>}
                                {!tempChartLoading && tempChartData?.length > 0 && <Plot
                                    useResizeHandler={true}
                                    data={tempChartData}
                                    className='model-chart'
                                    layout={{
                                        autosize: true,
                                        height: "100%",
                                        margin: {
                                            l: 40,
                                            r: 40,
                                            b: 20,
                                            t: 20,
                                            pad: 5
                                        },
                                        xaxis: {
                                            automargin: true,
                                            type: "date",
                                        },
                                        yaxis: {
                                            fixedrange: false,
                                            side: "left",
                                            range: [minValue - 1, maxValue + 1],
                                        },
                                        legend: {
                                            orientation: "h",
                                        },
                                        hoverdistance: 1,
                                        hovermode: "x unified",

                                    }} />}
                            </Card>
                        </div>

                        <div className='cancui-right-card'>
                            <Card className='cancui-details-card' bodyPadding={false}>
                                {isLoading && <div className='loading-container'><Loading /></div>}
                                {!isLoading && data && <div className='details-card-content'>
                                    <div className='details-card-content-col'>
                                        <div className='info-container'>
                                            <div className='info-data'>
                                                <p className='data-label'>Last Inspection Date</p>
                                                <p className='data-value'>{data?.lastInspectionDate ? moment(data.lastInspectionDate).format("YYYY-MM-DD") : "N/A"}</p>
                                            </div>
                                            <div className='info-data'>
                                                <p className='data-label'>Analysis Period</p>
                                                <p className='data-value'>{analysisDates?.start ? moment(analysisDates.start).format("YYYY-MM-DD") : "N/A"} - {analysisDates?.end ? moment(analysisDates.end).format("YYYY-MM-DD") : "N/A"}</p>
                                            </div>
                                            <div className='info-data'>
                                                <p className='data-label'>Cladding/Insulation Condition</p>
                                                <p className='data-value'>{data?.cladding_or_InsulationCondition}</p>
                                            </div>
                                            <div className='info-data'>
                                                <p className='data-label'>Coating Status</p>
                                                <p className='data-value'>{data?.coatingStatus}</p>
                                            </div>
                                            <div className='info-data'>
                                                <p className='data-label'>External Condition</p>
                                                <p className='data-value'>{data?.externalEnvironment}</p>
                                            </div>
                                            <div className='info-data'>
                                                <p className='data-label'>Insulation Type</p>
                                                <p className='data-value'>{data?.insulationType}</p>
                                            </div>
                                            <div className='info-data'>
                                                <p className='data-label'>Heat Tracing</p>
                                                <p className='data-value'>{data?.heatTracing}</p>
                                            </div>

                                        </div>
                                    </div>

                                </div>}
                            </Card>

                        </div>

                    </div>

                    <br />
                    {equipmentData?.operatingTemperatureScore > 0 && (!isCondensateRisk || (isCondensateRisk && isCondensateRiskAssementComplete && condensateRisk == 0 )) && <Card className='text-description-card'>
                        {equipmentData?.tempPercentWihinCUI === 100 ? <p className='data-value'>
                            The Operating Temperature score is calculated based on the Average temperature of the whole range. The Average temperature is {equipmentData?.avgOpTemp?.toFixed(2)} and Operating temperature score is {equipmentData?.operatingTemperatureScore}</p>
                            : ((equipmentData?.operatingTemperatureScore === 1 || equipmentData?.operatingTemperatureScore === 3 || equipmentData?.operatingTemperatureScore === 5) && equipmentData?.cluster_analysis) ? <p className='data-value'>
                                The Operating Temperature score is calculated based on the average temperature derived from the clusters identified, based on the clusters we have identified the equipment has Incidental Exposure.
                            </p> : (equipmentData?.operatingTemperatureScore === 1 && !equipmentData?.cluster_analysis) && <p className='data-value'>
                                Based on the average temperature there where no significant clusters, but there are few incidental exposure which was not long enough and to make sure comparison with other conditions like coating, insulation, and local weather we have set the operating temperature score as 1 for the equipment.
                            </p>}
                    </Card>}
                    {(isCondensateRiskAssementComplete || isCondensateRisk) &&
                        <>
                        <h4>Temperature vs Dew Point</h4>
                            <div key={`container-${equipmentData.id}`}>
                                <div key={equipmentData.id}>
                                    <CondensateRiskSummaryList units={units} equipmentData={equipmentData} analysisDates={analysisDates} />
                                </div>
                                <br />
                            </div>
                        </>
                    }
                    <h4>Temperature Formula</h4>
                    {(temperatureFormulaDataLoading) && <div className='loading-container'><Loading /></div>}
                    {!temperatureFormulaDataLoading && <Card className='text-description-card'>
                        {!temperatureFormulaData?.calculation_type && <p className='data-value'>{`No Temperature Formula Available, Nominal Temperature of ${equipmentData?.avgOpTemp?.toFixed(2)} is used`}</p>}
                        {temperatureFormulaData?.calculation_type && 
                            <div style={{width: '100%', display: 'grid'}}>
                                <p className='data-label'>{`Expression:`}</p>
                                {displayFormula.includes('\n') ?
                                    <>
                                    <br />
                                    <TextArea
                                        className='formula-text-area'
                                        value={displayFormula}
                                        readOnly
                                        style={{ height: `${Math.min(200, displayFormula.split('\n').length * 24)}px` }}
                                    />
                                    </>
                                    :
                                    <p className='data-value'>{displayFormula}</p>
                                }
                                <br />
                                <p className='data-label'>{`Data:`}</p>
                                <div className='tempFormula-date-container'>
                                    <div className='start-date-wrapper'>
                                        <div className='label-header'>
                                            <p className="data-label">Start Date</p>
                                            <Button variant='transparent' iconOnly />
                                        </div>
                                        <SingleDatePicker
                                            generateConfig={momentGenerateConfig}
                                            config="custom"
                                            format="DD/MM/yyyy"
                                            disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                                            value={!inValidtempFormulaStartDate && tempFormulaStartDate ? tempFormulaStartDate : inValidtempFormulaStartDate ? inValidtempFormulaStartDate : null}
                                            onChange={(date) => {
                                                setTempFormulaStartErrorText(null)
                                                setInValidtempFormulaStartDate(null)
                                                if (date.isBefore(tempFormulaEndDate)) {
                                                    handleDateChange(date, tempFormulaStartDate, setTempFormulaStartDate, "DD/MM/yyyy")
                                                }
                                                else if (date.isAfter(tempFormulaEndDate)) {
                                                    setTempFormulaStartErrorText("Start date cannot be after end date")
                                                    setInValidtempFormulaStartDate(date)
                                                }
                                                // if interval is Hour and date range is more than 30 days, show error
                                                if (tempFormulaInterval === 'HOUR' && tempFormulaEndDate.diff(date, 'days') > 30) {
                                                    setTempFormulaStartErrorText("For hourly intervals, the date range cannot exceed 30 days")
                                                }
                                            }}
                                            allowClear={false} />
                                        <p className="data-label error-label">{tempFormulaStartErrorText}</p>
                                    </div>
                                    <div className='end-date-wrapper'>
                                        <div className='label-header'>
                                            <p className="data-label">End Date</p>
                                            <Button variant='transparent' iconOnly />
                                        </div>
                                        <SingleDatePicker
                                            generateConfig={momentGenerateConfig}
                                            config="custom"
                                            format="DD/MM/yyyy"
                                            disabledDate={(curr) => curr ? curr.isAfter(moment().toDate()) : false}
                                            value={!inValidtempFormulaEndDate && tempFormulaEndDate ? tempFormulaEndDate : inValidtempFormulaEndDate ? inValidtempFormulaEndDate : null}
                                            onChange={(date) => {
                                                setTempFormulaEndErrorText(null)
                                                setInValidtempFormulaEndDate(null)
                                                if (date.isAfter(tempFormulaStartDate)) {
                                                    handleDateChange(date, tempFormulaEndDate, setTempFormulaEndDate, "DD/MM/yyyy")
                                                }
                                                else if (date.isBefore(tempFormulaStartDate)) {
                                                    setTempFormulaEndErrorText("End date cannot be before start date")
                                                    setInValidtempFormulaEndDate(date)
                                                }
                                                // if interval is Hour and date range is more than 30 days, show error
                                                if (tempFormulaInterval === 'HOUR' && date.diff(tempFormulaStartDate, 'days') > 30) {
                                                    setTempFormulaEndErrorText("For hourly intervals, the date range cannot exceed 30 days")
                                                }
                                            }}
                                            allowClear={false} />
                                        <p className="data-label error-label">{tempFormulaEndErrorText}</p>
                                    </div>
                                    <div className='end-date-wrapper'>
                                        <div className='label-header'>
                                            <p className="data-label">Interval</p>
                                            <Button variant='transparent' iconOnly />
                                        </div>
                                        <Select value={tempFormulaInterval} showSearch={false} allowClear={false} onChange={(value) => {
                                            if (value === 'HOUR' && tempFormulaEndDate.diff(tempFormulaStartDate, 'days') > 30) {
                                                setTempFormulaStartDate(DEFAULT_HOURLY_DATE_SPEC.initStart)
                                                setTempFormulaEndDate(DEFAULT_HOURLY_DATE_SPEC.initEnd)
                                                toast.info("Date range adjusted for hourly interval")
                                            }
                                            setTempFormulaInterval(value)
                                        }}>
                                            {['DAY', 'HOUR'].map((header, index) => {
                                                return <Option key={index} value={header}>{header}</Option>
                                            })}
                                        </Select>
                                    </div>
                                    {temperatureFormulaData?.calculation_type?.includes("PRESSURE") && 
                                    <div style={{margin: 'auto', width: '100%'}}> 
                                    <Button variant='filled' onClick={() => setPressureLookupOpen(true)} style={{fontSize: 12}}>View Pressure Lookup</Button>
                                    </div>
                                    }
                                </div>
                                <div style={{ zIndex: 1 , overflowX: 'auto'}}>
                                    <DataTable
                                        count={temperatureFormulaTagData?.length}
                                        columns={[
                                            {
                                                header: "Timestamp",
                                                accessorFn: (row) => row?.timestamp,
                                                id: "timestamp",
                                            },
                                            ...tags?.map((tag) => ({
                                                    header: pressure_tags?.includes(tag) ?`${tag} (barg)` : flow_tags?.includes(tag) ? `${tag} (t/h)` : `${tag} (°C)`,
                                                    accessorFn: (row) => row?.[tag],
                                                    id: tag,
                                                }))
                                            ,{
                                                header: "Calculated Temperature (°C)",
                                                accessorFn: (row) => row?.calculatedTemperature,
                                                id: "calculatedTemperature",
                                            }
                                        ]}
                                        data={temperatureFormulaTagData}
                                        currentPage={currentPage}
                                        handleCurrentPageChange={handleCurrentPageChange}
                                        handleOrderChange={() => {}}
                                        // INIT_ORDER={INIT_ORDER}
                                        // INIT_ORDER_DIRECTION={INIT_ORDER_DIRECTION}
                                        loading={temperatureFormulaTagDataLoading}
                                        paginationMode="client"
                                    />
                                </div>
                            </div>
                        }

                    </Card>}
                    {(isCondensateRiskAssementComplete || isCondensateRisk) &&
                        <>
                        <h4>Condensate Risk Assessment</h4>
                        <Card className='text-description-card'>
                            <p className='data-value'>{!isCondensateRiskAssementComplete ? `${equipmentData?.textDescription.slice(0, equipmentData?.textDescription?.indexOf('.'))}. Please Answer the below questions based on your risk assessment using the Temperature vs Dew Point Charts.` : ""}</p>
                            <br />
                            <p className={condensateRisk === -1 ? 'data-value' : 'data-label'}>Do you agree with the condensate risk ?</p>
                            {condensateRisk === -1 && <div>
                                <Button variant="filled" sentiment='positive' onClick={() => setCondensateRisk(1)}>Yes</Button>
                                <Button variant="filled" sentiment='negative' onClick={() => setCondensateRisk(0)}>No</Button>
                            </div>}
                            {condensateRisk == 1 &&<div>
                                <p className='data-value'>{agreedCondensateRiskText}</p>
                                {!isCondensateRiskAssementComplete && <><Button variant="filled" onClick={() => setCondensateRisk(-1)}>Change Answer</Button><br /></>}
                                <br />
                                <p className={coatingCondition === -1 ? 'data-value' : 'data-label'}>Is the coating condition acceptable ?</p>
                                {coatingCondition === -1 && <div>
                                    <Button variant="filled" sentiment='positive' onClick={() => setCoatingCondition(1)}>Yes</Button>
                                    <Button variant="filled" sentiment='negative' onClick={() => setCoatingCondition(0)}>No</Button>
                                </div>}
                                {coatingCondition === 1 && <div>
                                    <p className='data-value'>{agreedCoatingConditionText}</p>
                                    {!isCondensateRiskAssementComplete && <Button variant="filled" onClick={() => setCoatingCondition(-1)}>Change Answer</Button>}
                                </div>}
                                {coatingCondition === 0 && <div>
                                    <p className='data-value'>{disagreedCoatingConditionText}</p>
                                    {!isCondensateRiskAssementComplete && <Button variant="filled" onClick={() => setCoatingCondition(-1)}>Change Answer</Button>}
                                </div>}
                            </div>}
                            {condensateRisk == 0 && <div>
                                <p className='data-value'>{disagreedCondensateRiskText}</p>
                                {!isCondensateRiskAssementComplete && <Button variant="filled" onClick={() => setCondensateRisk(-1)}>Change Answer</Button>}
                            </div>}
                             <br />       
                            <p className={!isCondensateRiskAssementComplete ? 'data-value' : 'data-label'}>Please provide your comments:</p>
                            {!isCondensateRiskAssementComplete && <TextArea rows="4" cols="50" placeholder="Enter your comments here..." onChange={(e) => setComments(e.target.value)} value={comments}></TextArea>}
                            {isCondensateRiskAssementComplete && <div className='data-value'>{comments}</div>}
                            <br />
                            <div>
                                {!isCondensateRiskAssementComplete && <Button variant="filled" onClick={() => setOpen(true)} disabled={condensateRisk === -1 || (condensateRisk == 1 && coatingCondition === -1) || comments === ''}>Submit</Button>}
                                {isCondensateRiskAssementComplete && <div className='data-value'>Submitted by {condensateRiskAnsweredBy}</div>}
                            </div>
                        </Card>
                        </>
                    }
                    
                    {(!isCondensateRisk || (isCondensateRisk && isCondensateRiskAssementComplete)) && <><br />
                        <h4>Probability Score</h4>
                        <div className='cancui-card-container'>
                            <div className={equipmentData?.operatingTemperatureScore > 0 ? 'cancui-left-card' : ''}>
                                <Card bodyPadding={false} className='cancui-probability-card'>
                                    {equipmentData && <ProbabilityScoreGrid
                                        scores={{
                                            coatingStatusScore: equipmentData?.coatingStatusScore,
                                            claddingorInsulationConditionScore: equipmentData?.claddingorInsulationConditionScore,
                                            insulationTypeScore: equipmentData?.insulationTypeScore,
                                            heatTracingScore: equipmentData?.heatTracingScore,
                                            externalEnvScor: equipmentData?.externalEnvScore,
                                            operatingTemperatureScore: equipmentData?.operatingTemperatureScore,
                                        }}
                                    />}

                                </Card>

                            </div>
                            
                            {equipmentData?.operatingTemperatureScore > 0 &&
                                <div className='cancui-right-card'>
                                    <Card className='cancui-scores-card' bodyPadding={false}>
                                        <div className='cancui-scores-card-content'>
                                            <div className='probability-score-section'>
                                                <br />
                                                <table className="consequence-table">
                                                    <thead>
                                                        <tr>
                                                            <th colSpan="2" className="consequence-header">Scores</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Operating Temp Score</td>
                                                            <td>{equipmentData?.operatingTemperatureScore}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Cladding/Insulation Condition Score</td>
                                                            <td>{equipmentData?.claddingorInsulationConditionScore}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Coating Status Score</td>
                                                            <td>{equipmentData?.coatingStatusScore}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Insulation Type Score</td>
                                                            <td>{equipmentData?.insulationTypeScore}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Heat Tracing Score</td>
                                                            <td>{equipmentData?.heatTracingScore}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>External Environment Score</td>
                                                            <td>{equipmentData?.externalEnvScore}</td>
                                                        </tr>
                                                        <tr className="highlighted-consequence-row">
                                                            <td>Total Probability Score</td>
                                                            <td>{equipmentData?.cumulativeScore}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <br />
                                            <div className='consequence-section'>
                                                <table className="consequence-table">
                                                    <thead>
                                                        <tr>
                                                            <th colSpan="2" className="consequence-header">Consequence Category</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Asset</td>
                                                            <td>{data?.asset}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Environment</td>
                                                            <td>{data?.environment}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>People</td>
                                                            <td>{data?.people}</td>
                                                        </tr>
                                                        <tr className="highlighted-consequence-row">
                                                            <td>Consequence</td>
                                                            <td>{equipmentData?.consequence}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <br />
                                            <div className='crticality-section'>
                                                <table className='criticality-table'>
                                                    <thead>

                                                        <tr>
                                                            <th colSpan={1} className="criticality-header">Probability Class</th>
                                                            <th colSpan={5} className="criticality-header">Criticality</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <tr>
                                                            <td className={getHighlightClass('H', equipmentData?.cumulativeScore)}>
                                                                H ({probabilityClassMap['H']})
                                                            </td>
                                                            <td className={shouldHighlightCriticality('H', 0, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(194,253,192)' }}>IS-4(L)</td>
                                                            <td className={shouldHighlightCriticality('H', 1, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(253,134,9)' }}>IS-3(MH)</td>
                                                            <td className={shouldHighlightCriticality('H', 2, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(252,17,8)' }}>IS-2(H)</td>
                                                            <td className={shouldHighlightCriticality('H', 3, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(251,38,251)' }}>IS-1(E)</td>
                                                            <td className={shouldHighlightCriticality('H', 4, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(251,38,251)' }}>IS-1(E)</td>
                                                        </tr>
                                                        <tr>
                                                            <td className={getHighlightClass('M', equipmentData?.cumulativeScore)}>
                                                                M ({probabilityClassMap['M']})
                                                            </td>
                                                            <td className={shouldHighlightCriticality('M', 0, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(194,253,192)' }}>IS-4(L)</td>
                                                            <td className={shouldHighlightCriticality('M', 1, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(255,252,26)' }}>IS-4(M)</td>
                                                            <td className={shouldHighlightCriticality('M', 2, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(253,134,9)' }}>IS-3(MH)</td>
                                                            <td className={shouldHighlightCriticality('M', 3, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(252,17,8)' }}>IS-2(H)</td>
                                                            <td className={shouldHighlightCriticality('M', 4, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(251,38,251)' }}>IS-1(E)</td>
                                                        </tr>
                                                        <tr>
                                                            <td className={getHighlightClass('L', equipmentData?.cumulativeScore)}>
                                                                L ({probabilityClassMap['L']})
                                                            </td>
                                                            <td className={shouldHighlightCriticality('L', 0, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(34,250,35)' }}>IS-4(N)</td>
                                                            <td className={shouldHighlightCriticality('L', 1, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(194,253,192)' }}>IS-4(L)</td>
                                                            <td className={shouldHighlightCriticality('L', 2, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(255,252,26)' }}>IS-4(M)</td>
                                                            <td className={shouldHighlightCriticality('L', 3, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(253,134,9)' }}>IS-3(MH)</td>
                                                            <td className={shouldHighlightCriticality('L', 4, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(252,17,8)' }}>IS-2(H)</td>
                                                        </tr>
                                                        <tr>
                                                            <td className={getHighlightClass('N', equipmentData?.cumulativeScore)}>
                                                                N ({probabilityClassMap['N']})
                                                            </td>
                                                            <td className={shouldHighlightCriticality('N', 0, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(34,250,35)' }}>IS-4(N)</td>
                                                            <td className={shouldHighlightCriticality('N', 1, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(34,250,35)' }}>IS-4(N)</td>
                                                            <td className={shouldHighlightCriticality('N', 2, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(194,253,192)' }}>IS-4(L)</td>
                                                            <td className={shouldHighlightCriticality('N', 3, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(255,252,26)' }}>IS-4(M)</td>
                                                            <td className={shouldHighlightCriticality('N', 4, equipmentData) ? 'highlighted-critical-cell' : ''} style={{ backgroundColor: 'rgb(253,134,9)' }}>IS-3(MH)</td>
                                                        </tr>
                                                        <tr className="consequence-class-row">
                                                            <td className='criticality-header'>Consequence Class</td>
                                                            <td className={equipmentData?.consequence === 'N' ? 'highlighted-cell' : ''}>N</td>
                                                            <td className={equipmentData?.consequence === 'L' ? 'highlighted-cell' : ''}>L</td>
                                                            <td className={equipmentData?.consequence === 'M' ? 'highlighted-cell' : ''}>M</td>
                                                            <td className={equipmentData?.consequence === 'H' ? 'highlighted-cell' : ''}>H</td>
                                                            <td className={equipmentData?.consequence === 'E' ? 'highlighted-cell' : ''}>E</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <p className='sub-text'>Equipment is flagged as Amber if the criticality is less than or equal to IS3 (MH), and as Green if it exceeds IS3 (MH)</p>
                                                <br />
                                            </div>

                                        </div>
                                    </Card>
                                </div>
                            }
                        </div>
                        <br /></>}                    
                    <Modal open={open} onClose={handleOnClose} size='large'
                        title='Confirm Submission'
                        // description='Are you sure you want to submit the answers?'
                        actions={[{
                            label: 'Cancel',
                            action: () => {
                                handleOnClose();
                            },
                            props: {
                                variant: 'outlined',
                                disabled: modalLoading
                            }

                        }, {
                            label: 'Confirm',
                            action: () => {
                                // handleOnClose();
                                handleOnConfirm();
                            },
                            props: {
                                variant: 'contained',
                                color: 'primary',
                                disabled: modalLoading
                            }
                        }]}>
                            <Text>
                                You are about to submit the answers for the CUI risk assessment. Please review your answers before submitting.
                                <br />
                                <br />
                                1. {condensateRisk == 1 ? agreedCondensateRiskText : disagreedCondensateRiskText}
                                <br />
                                {condensateRisk == 1 ? coatingCondition == 1 ? <>{`2. ${agreedCoatingConditionText}`}<br/></> : <>{`2. ${disagreedCoatingConditionText}`}<br/></> : ""}
                                {condensateRisk == 1 ? 3. : 2.} Your comments: {comments}
                            </Text>
                            <br />
                            {modalLoading && <div className='loading-container'><Loading /></div>}
                        </Modal>
                        <Modal open={pressureLookupOpen} onClose={handleOnPressureLookupClose} size='large'
                        title='Pressure Lookup Temperature'
                        // description='Are you sure you want to submit the answers?'
                        actions={[{
                            label: 'Close',
                            action: () => {
                                handleOnPressureLookupClose();
                            },
                            props: {
                                variant: 'outlined',
                            }

                        }]}>
                            <PressureLookupTemperature />
                        </Modal>
                </div>
    )
}

export default CancuiSensorDetails